export const settingAccommodation = {
    p1: `Grunddaten`,
    p2: `Geben Sie den Namen und das Logo an, die Gäste zu Beginn des Check-ins sehen. Ohne eigenes Logo wird das Standardlogo von WACheckin verwendet.`,
    p3: `Unterkunftsbedingungen`,
    p4: `Passen Sie die Bedingungen Ihrer Unterkunft an. Diese akzeptieren die Gäste beim Check-in.`,
    p5: `SPANISCH`,
    p6: `ENGLISCH`,
    p7: `Willkommensnachricht`,
    p8: `Passen Sie die Willkommensnachricht an, die Ihre Gäste nach dem Check-in sehen.`,
    p9: `Zimmerschlüssel`,
    p10: `Erfassen und verwalten Sie Zimmer mit smarten Schlössern. Legen Sie die Zugangscodes fest, die die Gäste nach dem Check-in für den Zutritt erhalten.`,
    p11: `Zuständige Behörden`,
    p12: `Richten Sie die Verbindung zu den örtlichen Behörden für die automatische Übermittlung der Gästemeldungen ein. Geben Sie Benutzername und Passwort für die Plattform der jeweiligen Behörde ein.`,
    p13: `Guardia Civil`,
    p14: `Nationalpolizei`,
    p15: `Ertzaintza`,
    p16: `Mossos`,
    p17: `Zugangsdaten`,
    p18: `Die Behörde ist erforderlich`,
    p19: `Der Benutzername ist erforderlich`,
    p20: `Das Passwort ist erforderlich`,
    p21: `Fehler beim Prüfen der Daten`,
    p22: `Die Behörde ist erforderlich`,
    p23: `Der Benutzername ist erforderlich`,
    p24: `Das Passwort ist erforderlich`,
    p25: `Daten erfolgreich aktualisiert`,
    p26: `Fehler beim Eingeben der Daten der Ausländerbehörde`,
    p27: `Laden Sie den QR-Code Ihrer Unterkunft für schnelle Check-ins herunter oder holen Sie sich den Link, den Sie direkt an die Gäste senden.`,
    p28: `Sicherheitscode der Unterkunft bearbeiten`,
    p29: `Wir prüfen die Identität der Gäste, indem wir das Foto im Ausweis oder Reisepass mit einem Selfie in Echtzeit vergleichen.`,
    p30: `Wenn Sie diese Option aktivieren, müssen die Gäste ihre Identität während des Check-ins bestätigen. Ohne erfolgreiche Prüfung können sie den Check-in nicht fortsetzen.`,
    p31: `Fehler beim Aktivieren der Identitätsprüfung`,
    p32: `Zahlungseinstellungen`,
    p33: `Kassieren Sie Gäste während des Check-ins, damit sie Zusatzleistungen und anfallende Gebühren bezahlen können.`,
    p34: `Sicherheitscode der Unterkunft`,
    p35: `Unterkunft`,
    p36: `Aktivieren Sie diese Option, um am Tag des Check-out automatisch eine WhatsApp-Nachricht zu senden, in der die Gäste ihren Aufenthalt von 1 bis 5 bewerten.`,
    p37: `Geben Sie die URL der Bewertungsseite an, auf der Ihre Gäste ihre Meinung hinterlassen sollen, ob bei Google oder einem anderen Portal, das Sie nutzen. Das verbessert Sichtbarkeit und Ruf der Unterkunft.`,
    p38: `URL der Bewertungsseite eingeben (z. B. Google, TripAdvisor)`,
    p39: `Unterkunft verwalten`,
    p40: `Grunddaten`,
    p41: `Unterkunftsbedingungen`,
    p42: `Willkommensnachricht`,
    p43: `QR der Unterkunft`,
    p44: `Gästezahlungen`,
    p45: `Logo der Unterkunft hochladen`,
    p46: `Sie können ein Bild hochladen oder in das Feld ziehen`,
    p47: `Design`,
    p48: `Bedingungen`,
    p49: `Willkommen`,
    p50: `Region`,
    p51: `Spanisch`,
    p52: `Englisch`,
    p53: `Arabisch`,
    p54:``,
    p55:``,
    p56:``,
    p57:``,
    p58:``,
    p59:``,
    p60:``,
    p61:``,
    p62:``,
    p63:``,
    p64:``,
    p65:``,
    p66:``,
    p67:``,
    p68:``,
    p69:``,
    p70:``,
};
